module.exports = __webpack_public_path__ + "site/img/Maps_2Tin Sau.19700fd1.jpg";